import { Paper, IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import '../../theme/newPost.css';

interface ImagePreviewProps {
  src: string;
  index: number;
  onRemove: () => void;
}

const ImagePreview: React.FC<ImagePreviewProps> = ({ src, index, onRemove }) => {
  const { t } = useTranslation();

  return (
    <Paper
      elevation={3}
      className="new-post-image-preview"
    >
      <img
        src={src}
        alt={t('new_post.image_preview', { index: index + 1 })}
      />
      <IconButton
        size="small"
        onClick={onRemove}
        className="new-post-image-delete"
      >
        <Close fontSize="small" />
      </IconButton>
    </Paper>
  );
};

export default ImagePreview;
